<template>
    <MainContainer background="darkGreyPartial" :style="{ 'background-position-y' : backgroundPosition}">
        <div class="col-xs-12 col-sm-8 col-md-7 col-lg-5 center tc">

            <!-- pre-box content -->
            <div class="pv5" ref="preBox">
                <h2 class="white ph3">Earn extra money by renting your tools & equipment.</h2>
            </div>

            <!-- the white box -->
            <div class="pv4 ph3 bg-white custom-shadow" ref="whiteBox">
                <div v-if="$auth.check()" class="ph3-m">
                    <h5>Start by giving your listing a descriptive title.</h5>
                    <Textbox class="mv3" placeholder="Listing title..." v-model="title" :focused="true" @keyup.enter="submit" />
                    <div class=" mb3 bodyCopy tl"><b>Example: </b>Ryobi 18-volt ONE+ Airstrike 18-Gauge Cordless Brad Nailer</div>
                    <TooliabaButton @click="submit">Continue</TooliabaButton>
                </div>
                <div v-else>
                    <div v-if="loginState === 'signIn'">
                        <h4 class="mb2">Please Sign In to start listing your tool.</h4>
                        <Login @forgotClick="loginState = 'reset'" :showBackButton="false" @signUpClick="loginState = 'signUp'"/>
                    </div>
                    <div v-if="loginState === 'signUp'">
                        <SignupCore/>
                        <div class="tc">
                            <div class="mt4">Already have an account?</div>
                            <a class="link black pointer" @click="loginState = 'signIn'"><h5 class="yellow mt1 mb3 grow">Log in</h5></a>
                        </div>
                    </div>
                    <div v-if="loginState === 'reset'">
                        <ResetPassword @backClick="loginState = 'signIn'"/>
                    </div>
                </div>
            </div>

            <!-- pre-benefits content -->
            <h4 class="mt5">Rent your tools and equipment with complete peace of mind.</h4>
            <img class="mt3" src="@/assets/img/icon_arrow_scroll.svg"/>
        </div>

        <!-- benefits -->
        <div class="tc row mv5 ">
            <Benefit
                title="Absolute Coverage"
                description="Owners and renters are covered under our comprehensive insurance">
                <img src="@/assets/img/icon_listmytools_coverage.svg"/>
            </Benefit>
            <Benefit
                title="Reliable Support Team"
                description="Get help every step of the way to make sure you have the best experience">
                <img src="@/assets/img/icon_listmytools_support.svg"/>
            </Benefit>
            <benefit
                title="Total Privacy"
                description="Our delivery system gives you  the flexibility to keep your location 100% private.">
                <img src="@/assets/img/icon_listmytools_privacy.svg"/>
            </benefit>
        </div>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import ImageLabel from '@/components/controls/ImageLabel.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import Benefit from '@/components/list/listingStart/Benefit.vue';
import Textbox from '@/components/controls/Textbox.vue';
import Login from '@/components/header/nav-items/Login.vue';
import SignupCore from '@/components/global/SignupCore.vue';
import ResetPassword from '@/components/header/nav-items/ResetPassword.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
    components: {
        MainContainer,
        ImageLabel,
        TooliabaButton,
        Benefit,
        Textbox,
        Login,
        SignupCore,
        ResetPassword
    },
    data() {
        return {
            title: '',
            backgroundPosition: null,
            loginState: 'signIn'
        };
    },
    methods: {
        ...mapMutations('newListing', ['resetListing']),
        ...mapActions('newListing', ['setTitle']),
        matchHeight() {
            const preBoxHeight = this.$refs.preBox.clientHeight;
            const halfBoxHeight = this.$refs.whiteBox.clientHeight / 2;
            const totalHeight = preBoxHeight + halfBoxHeight + 80;
            this.backgroundPosition = `${totalHeight - 1080}px`;
        },
        submit() {
            this.resetListing();
            this.setTitle(this.title);
            this.$router.push('/category');
        }
    },
    mounted() {
        this.matchHeight();
    }
};
</script>
